export const POSTS_PER_PAGE = parseInt(process.env.POSTS_PER_PAGE);